import { Flex, Spacer } from '@jisr-hr/ds'
import { DatePickerDSField, NewCheckBoxField } from 'components/final-form'
import { required } from 'components/global/form/FormValidations'
import { useForm, useFormState } from 'react-final-form'
import i18n from 'translations/i18n'
import { useSelector } from 'utils/hooks'
import { shallowEqual } from 'react-redux'

import AnnualLeaveConfigurationDetails from './AnnualLeaveConfigurationDetails'
import Styles from './AnnualLeave.module.css'
import { useAnnualLeaveBalanceConfiguration } from '../../helper'

type SelectRangeProps = {
  selectedTypeDetail?: {
    toil_available_balance?: number | null
    booked_toil_balance?: number | null
  }
}

const SelectRange = (props: SelectRangeProps): JSX.Element => {
  const { selectedTypeDetail } = props

  const toil_available_balance = selectedTypeDetail?.toil_available_balance ?? 0
  const booked_toil_balance = selectedTypeDetail?.booked_toil_balance ?? 0

  const { values } = useFormState()
  const { change } = useForm()

  const {
    total_deducted_and_reserved_balance,
    pending_balance,
    requested_days,
    toil_pending_balance,
    total_toil_deducted_and_reserved_balance,
  } = useSelector((s) => s.leaveRequests?.leave_requests_detail ?? {}, shallowEqual)

  const balanceConfig = useAnnualLeaveBalanceConfiguration({
    toil_balance_deduction_enabled: values?.toil_balance_deduction_enabled,
    total_deducted_and_reserved_balance,
    pending_balance,
    requested_days,
    total_toil_deducted_and_reserved_balance,
    toil_pending_balance,
    toil_available_balance,
  }).getAnnualLeaveBalanceConfiguration()

  return (
    <Flex
      flexCol
      style={{ gap: 16, width: '100%' }}
    >
      {toil_available_balance > 0 && (
        <NewCheckBoxField
          name="toil_balance_deduction_enabled"
          label={i18n.t('label.use_toil_balance_first_title')}
          description={i18n.t('label.use_toil_balance_first_available_days', {
            count: +(toil_available_balance ?? 0).toFixed(2),
            Count_total: booked_toil_balance,
          })}
        />
      )}

      <Flex
        style={{ gap: 8, width: '100%' }}
        className={Styles.datePickerField}
      >
        <DatePickerDSField
          name="from"
          label={i18n.t('first_day_off')}
          onChange={(): void => {
            change('to', null)
          }}
          validate={required}
        />
        <Spacer
          width="13px"
          height="2px"
          style={{
            background: 'var(--color-natural-gray-darker-0-new)',
            marginTop: '42px',
            minWidth: 13,
          }}
        />
        <DatePickerDSField
          name="to"
          label={i18n.t('last_day_off')}
          calenderProps={{
            minDate: new Date(values?.from),
          }}
          textFieldProps={{ disabled: !values?.from }}
          validate={required}
        />
      </Flex>

      {values?.to &&
        balanceConfig.map((args, index) => (
          <AnnualLeaveConfigurationDetails
            key={index}
            requestedRate={100}
            {...args}
          />
        ))}
    </Flex>
  )
}

export default SelectRange
